<ng-container *ngIf="!isMobile; else elseBlock">
    <!-- ['/mobilaty-stars'] -->
    <button
        class="header-icon"
        [routerLink]="['/' + lang + '/account/your-points']"
        mat-mini-fab
        #menuTrigger="matMenuTrigger"
        matBadgePosition="after"
        (mouseenter)="toggleMenu($event, true)"
        (mouseleave)="toggleMenu($event, false)"
        [matMenuTriggerFor]="viewList"
        id="starProgram"
        [ngClass]="{
            'white-outline':
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
            'icons-background':
                environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
            'defult-background-icons':
                !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
        }"
    >
        <!-- [ngStyle]="{'background-color' : environmentVariables.HEADER_ICONS_BACKGROUND_COLOR , 'color' : environmentVariables?.HEADER_ICONS_FILL_COLOR}" -->

        <mat-icon
        (mouseover)="changeIconFill=false"
        (mouseleave)="changeIconFill=true"
            id="favIcon"
            class="material-icons notranslate defulat-icons-color"
            [ngClass]="{
                'material-symbols-outlined':
                    (!environmentVariables?.ENABLE_HEADER_ICONS_FILL && changeIconFill),
                'icons-fill-color':
                    environmentVariables?.HEADER_ICONS_FILL_COLOR
            }"
        >
            star
        </mat-icon>
        <span
            *ngIf="
                (environmentVariables?.LOYALTY_PROVIDER == 'sadhan' &&
                    loyaltyData?.points &&
                    loyaltyData?.points != 0) ||
                (environmentVariables?.LOYALTY_PROVIDER != 'sadhan' &&
                    isAuthUser?.total_points &&
                    isAuthUser?.total_points != 0)
            "
            class="header-icon__badge"
            [ngClass]="{
                'icons-background icons-fill-color':
                    environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                    environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
                'defult-background-icons':
                    !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                    !environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND
            }"
        >
            <ng-container
                *ngIf="environmentVariables?.LOYALTY_PROVIDER != 'sadhan'"
            >
                {{ isAuthUser?.total_points ? isAuthUser.total_points : 0 }}
            </ng-container>
            <ng-container
                *ngIf="environmentVariables?.LOYALTY_PROVIDER == 'sadhan'"
            >
                {{ loyaltyData?.points }}
            </ng-container>
        </span>
    </button>

    <mat-menu #viewList="matMenu" [hasBackdrop]="false">
        <div
            class="drop-wrap"
            (mouseenter)="this.enteredMenu = true"
            (mouseleave)="closeMatMenu()"
        >
            <div class="cart-menu-list p-2" fxLayoutAlign="start center">
                <div class="px-3">
                    <h6 class="mb-0">
                        <p
                            *ngIf="
                                isAuthUser?.is_gold &&
                                environmentVariables?.LOYALTY_PROVIDER !=
                                    'sadhan'
                            "
                            class="m-0 user-type"
                        >
                            {{ "loyalty.goldUser" | translate
                            }}<span class="gold-user"></span>
                        </p>
                        <p
                            *ngIf="
                                !isAuthUser?.is_gold &&
                                environmentVariables?.LOYALTY_PROVIDER !=
                                    'sadhan'
                            "
                            class="m-0 user-type"
                        >
                            {{ "loyalty.silverUser" | translate }}
                            <span class="silver-user"></span>
                        </p>
                        <p class="m-0">
                            {{ "loyalty.yourPoints" | translate }}
                            {{
                                environmentVariables?.LOYALTY_PROVIDER ==
                                    "sadhan" && !isAuthUser?.is_guest
                                    ? loyaltyData?.points
                                    : isAuthUser?.total_points &&
                                      !isAuthUser?.is_guest
                                    ? isAuthUser.total_points
                                    : 0
                            }}
                            <ng-container
                                *ngIf="
                                    environmentVariables?.LOYALTY_PROVIDER ==
                                    'sadhan'
                                "
                            >
                                ({{ loyaltyData?.credit }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }})
                            </ng-container>
                        </p>
                    </h6>
                </div>
            </div>
            <div
                *ngIf="environmentVariables?.LOYALTY_PROVIDER != 'sadhan'"
                class="footer-menu px-3 pb-2 pt-2"
            >
                <button
                    mat-raised-button
                    color="accent"
                    class="w-100 color-primary"
                    (click)="checkUserGuest()"
                >
                    {{ "button.viewStarsPoints" | translate }}
                </button>
            </div>
        </div>
    </mat-menu>
</ng-container>
<ng-template #elseBlock>
    <button
        class="header-icon"
        [ngClass]="{
            'white-outline':
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
            'icons-background':
                environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
            'defult-background-icons':
                !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
        }"
        [routerLink]="['/' + lang + '/account/your-points']"
        (click)="checkUserGuest()"
        mat-mini-fab
        matBadgePosition="after"
    >
        <mat-icon
            class="material-icons notranslate defulat-icons-color"
            [ngClass]="{
                'material-symbols-outlined':
                    !environmentVariables?.ENABLE_HEADER_ICONS_FILL,
                'icons-fill-color':
                    environmentVariables?.HEADER_ICONS_FILL_COLOR
            }"
        >
            star
        </mat-icon>
    </button>
</ng-template>
